<i18n>
{
  "fr": {
      "submit": "Soumettre",
      "cancel": "Annuler",
      "title": "Edition de la propriété",
      "processing": "Traitement en cours...",
      "technical": "Technique",
      "synoptic": "Synoptique",
      "schemas": "Schémas",
      "download": "Télécharger",
      "uploadFiles": "Pièces jointes"
  }
}
</i18n>

<template>
  <b-row :class="{noActive : isProcessing }" class="list-container property">

    <div :class="{ 'no-data-message': isProcessing }" id="processing-message" class="message">
      <div class="content">
        <h4 class="align-center">
          <slot name="Loading">{{ this.$i18n.t('processing') }}</slot>
        </h4>
      </div>
    </div>
    <b-col :class="{ 'no-data': isProcessing }" class="col-12">
      <form id="property" name="dynamic-validation" @submit.prevent="handleSubmitEditProperty">
        <PropertyFields
          :title="this.$i18n.t('title')"
          :propertyForm="propertyForm"
          :propertyFolderNumber="propertyFormAll.propertyFolderNumber"
        />
        <ConceptionFields name="conceptionFields" :propertyForm="propertyForm" />

        <div class="panel panel-info conception-forms"> 
            <div class="panel-heading" v-on:click="uploadFileVisibilityToggle()">
              {{ $t('uploadFiles') }}
              <div class="pull-right" v-b-toggle.filesDropzoneConceptionColl variant="primary">
                <span v-show="uploadFileVisibility">
                  <i class="fa fa-chevron-up curs"></i>
                </span>
                <span v-show="!uploadFileVisibility">
                  <i class="fa fa-chevron-down curs"></i>
                </span>
              </div>
            </div>
            <div v-show="uploadFileVisibility" class="panel-body">
              <div class="row">
                <div class="col-sm-12">
                  <filesDropzoneConception name="filesDropzoneConception" :withouPanel="true" />
                </div>
              </div>
            </div>
        </div>

        <div class="panel panel-info conception-forms">
          <div class="panel-heading" v-on:click="schemasVisibilityToggle()">
            {{ $t('schemas') }}
            <div class="pull-right" v-b-toggle.filesDropzoneConceptionColl variant="primary">
              <span v-show="schemasVisibility">
                <i class="fa fa-chevron-up curs"></i>
              </span>
              <span v-show="!schemasVisibility">
                <i class="fa fa-chevron-down curs"></i>
              </span>
            </div>
          </div>
          <div v-show="schemasVisibility" class="panel-body">
            <div class="row">
              <div v-if="propertyForm.technicalDrawingImage" class="col-sm-6 text-center">
                <h4 class="header-title">{{ $t('technical') }}</h4>
                <img v-bind:src="getFileUrl(propertyForm.technicalDrawingImage.id)" class="img-responsive">
                <br>
                <a v-bind:href="getFileUrl(propertyForm.technicalDrawingImage.id)" target="_blank">{{ $t('download') }}</a>
              </div>
              <div v-if="propertyForm.synopticDrawingImage" class="col-sm-6 text-center">
                <h4 class="header-title">{{ $t('synoptic') }}</h4>
                <img v-bind:src="getFileUrl(propertyForm.synopticDrawingImage.id)" class="img-responsive">
                <br>
                <a v-bind:href="getFileUrl(propertyForm.synopticDrawingImage.id)" target="_blank">{{ $t('download') }}</a>
              </div>
            </div>
          </div>
        </div>
        
        <RaccordementFields name="raccordementFields" :propertyForm="propertyForm" />
        <b-row>
          <b-col cols="6">
            <router-link
              class="btn btn-gray"
              :to="{ name: 'property_detail', params: { propertyId: id } }"
            >{{ $t('cancel') }}</router-link>
          </b-col>
          <b-col cols="6" class="submit-form">
            <b-button type="submit" class="btn btn-cta s-btn">
              <b-spinner v-if="isProcessing" />
              {{ $t('submit') }}
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-col>
    <ajax-intercept @start="ajaxStart" @finish="ajaxFinish"></ajax-intercept>
  </b-row>
</template>

<script>
import PropertyFields from '../../fields/PropertyFields.vue';
import ConceptionFields from '../../fields/ConceptionFields.vue';
import RaccordementFields from '../../fields/RaccordementFields.vue';
import { mapActions, mapState } from 'vuex';
import ajaxIntercept from 'vue-ajax-intercept';
import { getEndpoint } from '../../../store/endpoints';
import DropzoneConception from '../../DropzoneConception';

export default {
  name: 'propertyForm',
  components: {
    PropertyFields,
    ConceptionFields,
    RaccordementFields,
    ajaxIntercept,
    filesDropzoneConception: DropzoneConception,
  },
  data: () => ({
    isProcessing: false,
    aleardyUpdateForm: false,
    ajaxInterceptorCounter: 0,
    schemasVisibility: false,
    uploadFileVisibility: false,
  }),
  created() {
    this.getProperty();
    this.initNotif();
  },
  mounted() {
    if (!this.aleardyUpdateForm) {
      this.updateForm();
    }
  },
  computed: {
    ...mapState({
      propertyFormAll: state => state.propertyForm,
      propertyForm: state => state.propertyForm.propertyForm,
      id: state => state.route.params.propertyId,
    }),
  },
  methods: {
    ...mapActions(['getProperty', 'initNotif']),
    handleSubmitEditProperty() {
      this.isProcessing = true;
      this.setFilesInForm();
      
      // Remove extra fields
      delete this.propertyForm.technicalDrawingXml;
      delete this.propertyForm.technicalDrawingImage;
      delete this.propertyForm.synopticDrawingXml;
      delete this.propertyForm.synopticDrawingImage;
      delete this.propertyForm.isBanValid;

      this.$store.dispatch('handleSubmitEditProperty');
    },
    getComponentConnection() {
      var raccordementComponent = this.$children.find(x => x.$attrs.name === 'raccordementFields');
      return raccordementComponent.$children.filter(x => x.$attrs.name === 'filesDropzoneConnection');
    },
    getComponentConception() {
      return this.$children.find(x => x.$attrs.name === 'filesDropzoneConception');
    },
    updateForm() {
      //Raccordement
      var connectionComponents = this.getComponentConnection();
      connectionComponents.forEach((component, index) => {
        let attachement = this.propertyForm.raccordement.connections[index].attachement;
        this.$store.dispatch('joinFilesToPropertyForm', { component: component, attachement: attachement });
      });

      //Conception
      var dropzoneConceptionComponent = this.getComponentConception();
      this.$store.dispatch('joinFilesToPropertyForm', {
        component: dropzoneConceptionComponent,
        attachement: this.propertyForm.conception.attachement,
      });
    },
    setFilesInForm() {
      //Raccordement
      if (this.propertyForm.raccordement.connections.length > 0) {
        var connectionComponents = this.getComponentConnection();
        connectionComponents.forEach((component, index) => {
          Object.entries(component.$refs).map(([key, field]) => {
            let cleanFiles = [];
            let files = field.dropzone.files;
            for (var i = 0; i < files.length; i++) {
              var file = files[i];
              delete file.dataURL;
              delete file.previewTemplate;
              delete file.previewElement;

              cleanFiles.push(file);
            }
            if (this.propertyForm.raccordement.connections[index].attachement !== null) {
              this.propertyForm.raccordement.connections[index].attachement[key] = cleanFiles;
            } else {
              this.propertyForm.raccordement.connections[index].attachement = { [key]: cleanFiles };
            }
          });
        });
      }

      //Conception
      if (this.propertyForm.conception.attachement != null) {
        var dropzoneConceptionComponent = this.getComponentConception();
        this.$store.dispatch('setFilesInForm', {
          component: dropzoneConceptionComponent,
          form: this.propertyForm.conception.attachement,
        });
      }
    },
    ajaxStart() {
      this.ajaxInterceptorCounter++;
      this.isProcessing = true;
    },
    ajaxFinish() {
      this.ajaxInterceptorCounter--;
      if (this.ajaxInterceptorCounter <= 0) {
        this.isProcessing = false;
      }
    },
    schemasVisibilityToggle: function() {
      this.schemasVisibility = !this.schemasVisibility;
    },
    getFileUrl: function (fileId) {
      return getEndpoint('properties', null, null, fileId, null).absoluteDownloadUrl;
    },
    uploadFileVisibilityToggle: function(){
      this.uploadFileVisibility = !this.uploadFileVisibility;
    },
  },
};
</script>
